<template>
  <div ref="container"></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'

let scriptPromise = null

function loadTurnstileScript () {
	if (window.turnstile) return Promise.resolve()
	if (!scriptPromise) {
		scriptPromise = new Promise((resolve, reject) => {
			const script = document.createElement('script')
			script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
			script.async = true
			script.defer = true
			script.onload = resolve
			script.onerror = reject
			document.head.appendChild(script)
		})
	}
	return scriptPromise
}
</script>

<script setup>
/* global defineProps, defineEmits, defineExpose */
const props = defineProps({
	sitekey: {
		type: String,
		required: true
	}
})

const emit = defineEmits(['verify', 'expired'])

const container = ref(null)
let widgetId = null

function reset () {
	emit('expired')
	if (widgetId !== null && window.turnstile) {
		window.turnstile.reset(widgetId)
	}
}

function resetRestoredWidget (event) {
	if (event.persisted) {
		reset()
	}
}

onMounted(() => {
	window.addEventListener('pageshow', resetRestoredWidget)
	loadTurnstileScript()
		.then(() => {
			widgetId = window.turnstile.render(container.value, {
				sitekey: props.sitekey,
				callback: (token) => emit('verify', token),
				'expired-callback': () => emit('expired')
			})
		})
		.catch((err) => {
			console.error('Failed to load Turnstile script:', err)
		})
})

onBeforeUnmount(() => {
	window.removeEventListener('pageshow', resetRestoredWidget)
	if (widgetId !== null && window.turnstile) {
		window.turnstile.remove(widgetId)
	}
})

defineExpose({ reset })
</script>
